var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
//!!!! WARNING !!!!!!!!
//This is an auto generated file.
//Changes to this code will be lost if the code is regenerated.
//Generated by: TsAppClientBuilder
//Contact #dev-ui-platform-support in case of issues
import { GeneratedApiClient } from "./ApiClient";
import { AppLogNoAuthService } from "./service/AppLogNoAuthService";
import { CarApplicationService } from "./service/CarApplicationService";
import { CarRentalPaymentService } from "./service/CarRentalPaymentService";
import { DriverEarningsService } from "./service/DriverEarningsService";
import { DriverSessionHistoryService } from "./service/DriverSessionHistoryService";
import { FleetCarService } from "./service/FleetCarService";
import { FleetCompanyNoAuthService } from "./service/FleetCompanyNoAuthService";
import { FleetCompanyService } from "./service/FleetCompanyService";
import { FleetDriverInvitationService } from "./service/FleetDriverInvitationService";
import { FleetInboxService } from "./service/FleetInboxService";
import { FleetIntegrationControlService } from "./service/FleetIntegrationControlService";
import { FleetOwnerAuthNoAuthService } from "./service/FleetOwnerAuthNoAuthService";
import { FleetOwnerAuthService } from "./service/FleetOwnerAuthService";
import { FleetOwnerNoAuthService } from "./service/FleetOwnerNoAuthService";
import { FleetOwnerPortalService } from "./service/FleetOwnerPortalService";
import { FleetOwnerRegistrationNoAuthService } from "./service/FleetOwnerRegistrationNoAuthService";
import { FleetOwnerRegistrationService } from "./service/FleetOwnerRegistrationService";
import { FleetOwnerReportingService } from "./service/FleetOwnerReportingService";
import { FleetOwnerService } from "./service/FleetOwnerService";
import { FleetOwnerVerificationNoAuthService } from "./service/FleetOwnerVerificationNoAuthService";
import { FleetOwnerVerificationService } from "./service/FleetOwnerVerificationService";
import { FleetPortalDocumentService } from "./service/FleetPortalDocumentService";
import { FleetPortalOrderService } from "./service/FleetPortalOrderService";
import { FleetRegistrationService } from "./service/FleetRegistrationService";
import { FleetShiftManagementService } from "./service/FleetShiftManagementService";
import { HoldingFleetService } from "./service/HoldingFleetService";
import { InvoicingFiscalizationService } from "./service/InvoicingFiscalizationService";
import { LeadToFleetService } from "./service/LeadToFleetService";
import { OrderFleetService } from "./service/OrderFleetService";
import { VehicleMarketplaceService } from "./service/VehicleMarketplaceService";
/* tslint:disable:no-namespace */
export var FleetOwnerPortal;
(function (FleetOwnerPortal) {
    var ApiClient = /** @class */ (function (_super) {
        __extends(ApiClient, _super);
        function ApiClient(config) {
            var _this = _super.call(this, config) || this;
            _this.appLogNoAuth = new AppLogNoAuthService.ApiClient(config);
            _this.carApplication = new CarApplicationService.ApiClient(config);
            _this.carRentalPayment = new CarRentalPaymentService.ApiClient(config);
            _this.driverEarnings = new DriverEarningsService.ApiClient(config);
            _this.driverSessionHistory = new DriverSessionHistoryService.ApiClient(config);
            _this.fleetCar = new FleetCarService.ApiClient(config);
            _this.fleetCompany = new FleetCompanyService.ApiClient(config);
            _this.fleetCompanyNoAuth = new FleetCompanyNoAuthService.ApiClient(config);
            _this.fleetDriverInvitation = new FleetDriverInvitationService.ApiClient(config);
            _this.fleetInbox = new FleetInboxService.ApiClient(config);
            _this.fleetIntegrationControl = new FleetIntegrationControlService.ApiClient(config);
            _this.fleetOwner = new FleetOwnerService.ApiClient(config);
            _this.fleetOwnerAuth = new FleetOwnerAuthService.ApiClient(config);
            _this.fleetOwnerAuthNoAuth = new FleetOwnerAuthNoAuthService.ApiClient(config);
            _this.fleetOwnerNoAuth = new FleetOwnerNoAuthService.ApiClient(config);
            _this.fleetOwnerPortal = new FleetOwnerPortalService.ApiClient(config);
            _this.fleetOwnerRegistration = new FleetOwnerRegistrationService.ApiClient(config);
            _this.fleetOwnerRegistrationNoAuth = new FleetOwnerRegistrationNoAuthService.ApiClient(config);
            _this.fleetOwnerReporting = new FleetOwnerReportingService.ApiClient(config);
            _this.fleetOwnerVerification = new FleetOwnerVerificationService.ApiClient(config);
            _this.fleetOwnerVerificationNoAuth = new FleetOwnerVerificationNoAuthService.ApiClient(config);
            _this.fleetPortalDocument = new FleetPortalDocumentService.ApiClient(config);
            _this.fleetPortalOrder = new FleetPortalOrderService.ApiClient(config);
            _this.fleetRegistration = new FleetRegistrationService.ApiClient(config);
            _this.fleetShiftManagement = new FleetShiftManagementService.ApiClient(config);
            _this.holdingFleet = new HoldingFleetService.ApiClient(config);
            _this.invoicingFiscalization = new InvoicingFiscalizationService.ApiClient(config);
            _this.leadToFleet = new LeadToFleetService.ApiClient(config);
            _this.orderFleet = new OrderFleetService.ApiClient(config);
            _this.vehicleMarketplace = new VehicleMarketplaceService.ApiClient(config);
            return _this;
        }
        return ApiClient;
    }(GeneratedApiClient));
    FleetOwnerPortal.ApiClient = ApiClient;
})(FleetOwnerPortal || (FleetOwnerPortal = {}));
